"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowProperty;
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function (obj) {
    return obj == null ? void 0 : obj[key];
  };
}